var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFavoriteAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Favorit Delivery"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.12598,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 4.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.626 19.5H16.626M19.126 17V22",
    stroke: "#676767",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.71721 8.68881C10.3908 7.22431 12.9269 7.50445 14.2549 9.31211L14.2549 9.31213L14.5215 9.67507C14.6629 9.86742 14.8873 9.98102 15.126 9.98102C15.3646 9.98102 15.5891 9.86742 15.7304 9.67507L15.997 9.31213L15.997 9.31212C17.325 7.50445 19.8611 7.22431 21.5347 8.68881C23.2326 10.1746 23.3339 12.8305 21.7504 14.4471L21.7504 14.4471L20.8669 15.349C21.3448 15.5497 21.7808 15.8305 22.158 16.1746L22.822 15.4967L22.822 15.4967C25.0067 13.2664 24.8706 9.61471 22.5225 7.55998C20.318 5.63088 17.0403 5.87553 15.126 8.00832C13.2117 5.87553 9.93391 5.63088 7.72941 7.55998C5.38132 9.61471 5.2453 13.2664 7.42992 15.4967L7.42993 15.4967L14.1188 22.3255L14.1188 22.3255C14.5805 22.7968 15.2855 22.8756 15.8286 22.5621C15.4001 22.1009 15.0672 21.5497 14.8613 20.94L8.5015 14.4471L8.5015 14.4471C6.91803 12.8305 7.0193 10.1746 8.71721 8.68881L8.71721 8.68881Z",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 202",
    cx: 19.126,
    cy: 19.5,
    r: 4,
    stroke: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 7",
    d: "M20.126 13.5C21.126 13 21.626 11 21.126 10.5",
    stroke: "#676767",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.12598,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 4.5,
    stroke: "#EBEBEB"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteAdd);
export default __webpack_public_path__ + "static/media/favorite-add.983e60cbafeb67cf9a485fa3198bbd7a.svg";
export { ForwardRef as ReactComponent };